// ------------------------------------------------------------------------------
// DecorativeTitle
// author: mudas
// created: 2024/12/23
// ------------------------------------------------------------------------------

import React, { FC, ReactNode } from 'react';

import cx from './DecorativeTitle.module.css';

export interface IProps {
  title: ReactNode;
  description?: ReactNode;

  // 若设置样式则可能覆盖默认样式
  className?: string;

  // 是否显示前导符号（默认：true）
  leadingSymbol?: boolean;
}

const DecorativeTitle: FC<IProps> = (props) => {
  const { title, description, leadingSymbol = true, className } = props;

  return (
    <div className={cx('decorative-title', { leading: leadingSymbol }, className)}>
      {title && <div>{title}</div>}
      {description && <div className={cx('description')}>{description}</div>}
    </div>
  );
};

export default DecorativeTitle;
